import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'

import {getData} from '../../../apis/analysis/getData'

const useQueryData = (days: number, group: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getData(group),
        queryFn: async () => {
            const {data} = await getData(days, group)
            return data
        },
    })

    return {data, refetch}
}

export default useQueryData
